<div
    class="bazis-map"
    #mapElement
    [class.bazis-map_grayscale]="tileMode === 'grey'"
    [class.tms-map_medium]="lassoIsActive"
></div>
<ng-container
    *ngIf="{
        settings: settings$ | async,
        map: map$ | async,
    } as data"
>
    <ng-container *ngIf="data.map">
        <!-- <app-resize-map-control
            *ngIf="resizeControlEnabled"
            class="tms-map__control-resize"
            [isColllapse]="isColllapse"
            (click)="isColllapse = !isColllapse"
        ></app-resize-map-control> -->
        <div class="bazis-map__base-control bazis-map__base-control_top">
            <div class="bh-flex">
                <app-map-lasso-control
                    *ngIf="lassoEnabled"
                    [map]="data.map"
                    (selected)="lassoSelected.emit($event)"
                    (click)="toogleLasso()"
                ></app-map-lasso-control>

                <app-map-search-control *ngIf="showSearch"></app-map-search-control>
            </div>
            <div class="bh-flex-column">
                <bazis-map-zoom-control
                    *ngIf="zoomControlEnabled"
                    [map]="data.map"
                    fillButton="solid"
                ></bazis-map-zoom-control>

                <ng-content select="controlPanels"></ng-content>

                <bazis-map-tiles-control
                    *ngIf="tileControlEnabled && data.settings.tiles?.length > 1"
                    [tiles]="data.settings.tiles"
                    [selectedTileId]="selectedTileId"
                    (setTileLayer)="setTileLayer($event)"
                ></bazis-map-tiles-control>

                <bazis-map-open-modal-control
                    *ngIf="openModalControlEnabled"
                    [mapSettings$]="settings$"
                    [mapLayers$]="layers$"
                    [mapPopupInfo$]="popupInfo$"
                ></bazis-map-open-modal-control>
            </div>
        </div>
        <div class="bazis-map__base-control bazis-map__base-control_bottom">
            <!-- for legend -->
            <ng-content select="bottom"></ng-content>
        </div>
    </ng-container>
</ng-container>

<ng-container *ngIf="executeFitLayersBounds$ | async"></ng-container>
<ng-container *ngIf="mapSelected$ | async"></ng-container>
<ng-container *ngIf="popupActions$ | async"></ng-container>
<ng-container *ngIf="select$ | async"></ng-container>
<ng-container *ngIf="dragged$ | async"></ng-container>
<ng-container *ngIf="centerOnCoordinates$ | async"></ng-container>
<ng-container *ngIf="resized$ | async"></ng-container>
<ng-container *ngIf="layers$ | async"></ng-container>
